/**
 * findProhibitedWords checks the given text for any words from the
 * comma-separated prohibited word list, using case-insensitive whole-word
 * matching.
 *
 * Only whole words are matched — e.g. "fee" will not match inside "coffee".
 * The list is sourced from the school option
 * `hero:nswDOE:prohibitedFinancialLanguage` (SMOS-012).
 *
 * @param {string} text - The input text to validate.
 * @param {string} wordListString - Comma-separated list of prohibited words.
 * @returns {string[]} Array of prohibited words found in the text.
 */
export function findProhibitedWords(
  text: string | null | undefined,
  wordListString: string | null | undefined,
): string[] {
  if (!text || !wordListString) return [];
  const words = wordListString
    .split(',')
    .map((w) => w.trim().toLowerCase())
    .filter(Boolean);
  return words.filter((word) => {
    // Escape any special regex characters in the word before building the
    // pattern, so entries like "e.g." in the list don't break the regex.
    const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`\\b${escaped}\\b`, 'i');
    return regex.test(text);
  });
}
